var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconXThinFull = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#969699",
  d: "M13.151.146a.5.5 0 0 1 .707.708L7.71 7.002l6.15 6.15a.5.5 0 0 1-.708.706L7.002 7.71l-6.148 6.15a.5.5 0 0 1-.708-.708l6.149-6.149L.146.854A.5.5 0 1 1 .854.146l6.148 6.149z"
})));
export default SvgIconXThinFull;